import { IBannerReponse } from "../../../model/base/response/banner-response";
import { INewsReponse } from "../../../model/base/response/news-response";
import { IGroupedDailyOfficialResponse } from "../../../model/base/response/grouped-daily-official-response";
import { ICategoryWithSubcategoriesResponse } from "../../../model/base/response/category-with-subcategories-response";

export type HomeState = {
  banners: IBannerReponse[];
  news: INewsReponse[];
  activeSlide: number;
  activeNewsSlide: number;
  loading: boolean;
  loadingNews: boolean;
  errorNews: string | null;
  groupedDailyOfficial: IGroupedDailyOfficialResponse[];
  categoriesWithSubcategories: ICategoryWithSubcategoriesResponse[];
  loadingPublications: boolean;
};

export enum ACTION_TYPES {
  loadingBanners = 'loadingBanners',
  loadingNews = 'loadingNews',
  setActiveSlide = 'setActiveSlide',
  setActiveNewsSlide = 'setActiveNewsSlide',
  setLoading = 'setLoading',
  setLoadingNews = 'setLoadingNews',
  setErrorNews = 'setErrorNews',
  clearData = 'clearData',
  setGroupedDailyOfficial = 'setGroupedDailyOfficial',
  setCategoriesWithSubcategories = 'setCategoriesWithSubcategories',
  setLoadingPublications = 'setLoadingPublications'
}

export type HomeAction = {
  type: ACTION_TYPES;
  payload?: any;
};

export const initialState: HomeState = {
  banners: [],
  news: [],
  activeSlide: 0,
  activeNewsSlide: 0,
  loading: true,
  loadingNews: true,
  errorNews: null,
  groupedDailyOfficial: [],
  categoriesWithSubcategories: [],
  loadingPublications: true,
};

export const HomeReducer = (state: HomeState, action: HomeAction): HomeState => {
  switch (action.type) {
    case ACTION_TYPES.loadingBanners:
      return {
        ...state,
        banners: action.payload,
        loading: false,
      };
    case ACTION_TYPES.loadingNews:
      return {
        ...state,
        news: action.payload,
        loadingNews: false,
        errorNews: null,
      };
    case ACTION_TYPES.setActiveSlide:
      return {
        ...state,
        activeSlide: action.payload,
      };
    case ACTION_TYPES.setActiveNewsSlide:
      return {
        ...state,
        activeNewsSlide: action.payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case ACTION_TYPES.setLoadingNews:
      return {
        ...state,
        loadingNews: action.payload,
      };
    case ACTION_TYPES.setErrorNews:
      return {
        ...state,
        errorNews: action.payload,
        loadingNews: false,
      };
    case ACTION_TYPES.clearData:
      return initialState;
    case ACTION_TYPES.setGroupedDailyOfficial:
      return {
        ...state,
        groupedDailyOfficial: action.payload,
        loadingPublications: false,
      };
    case ACTION_TYPES.setCategoriesWithSubcategories:
      return {
        ...state,
        categoriesWithSubcategories: action.payload,
        loadingPublications: false,
      };
    case ACTION_TYPES.setLoadingPublications:
      return {
        ...state,
        loadingPublications: action.payload,
      };
    default:
      return state;
  }
};
